import { Bell, Grid3X3, Heart, Home, MessageSquare, Search, ShoppingCart, User } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import logo from "../../assets/brand-logo.png";
import { categoryGroups, storefrontNav } from "../../data/navigation";

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : undefined);

export function StorefrontShell() {
  const [megaOpen, setMegaOpen] = useState(false);

  return (
    <>
      <div className="topbar">
        <div className="container">
          <div className="topbar-left">
            <strong>Siêu Thị Ưa Thích</strong>
            <span>Phụ tùng chính hãng - an tâm vận hành</span>
          </div>
          <div className="topbar-right">
            <span>Hotline kỹ thuật</span>
            <span>B2B / Đại lý</span>
            <span>Tra cứu đơn</span>
          </div>
        </div>
      </div>
      <header className="site-header">
        <div className="container header-main">
          <Link className="logo-wrap" to="/" aria-label="Trang chủ Siêu Thị Ưa Thích">
            <img src={logo} alt="Logo Siêu Thị Ưa Thích" />
            <span className="logo-copy">
              <strong>SIÊU THỊ ƯA THÍCH</strong>
              <small>Phụ tùng chính hãng - an tâm vận hành</small>
            </span>
          </Link>
          <button
            className="category-trigger"
            type="button"
            aria-expanded={megaOpen}
            onClick={() => setMegaOpen((value) => !value)}
          >
            <Grid3X3 aria-hidden="true" />
            Danh mục
          </button>
          <form className="searchbox" onSubmit={(event) => event.preventDefault()}>
            <input aria-label="Từ khóa tìm kiếm" placeholder="Tìm phụ tùng, mã SKU, dòng xe..." />
            <select aria-label="Nhóm hàng" defaultValue="all">
              <option value="all">Tất cả</option>
              <option value="xe-dien">Xe điện</option>
              <option value="xe-may">Xe máy</option>
              <option value="oto-dien">Ô tô điện</option>
            </select>
            <button type="submit" aria-label="Tìm kiếm">
              <Search aria-hidden="true" />
            </button>
          </form>
          <div className="header-actions">
            <Link className="header-action" to="/account">
              <User aria-hidden="true" />
              <span className="txt">Tài khoản</span>
            </Link>
            <Link className="header-action" to="/account/wishlist">
              <Heart aria-hidden="true" />
              <span className="txt">Yêu thích</span>
            </Link>
            <Link className="header-action cart" to="/cart">
              <ShoppingCart aria-hidden="true" />
              <span className="txt">Giỏ hàng</span>
              <span className="cart-count">3</span>
            </Link>
          </div>
        </div>
        <nav className="navbar" aria-label="Điều hướng storefront">
          <div className="container">
            {storefrontNav.map((item) => (
              <NavLink key={item.href} to={item.href} className={navClass}>
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
        <div className={`mega ${megaOpen ? "open" : ""}`}>
          <div className="mega-grid">
            {categoryGroups.map((group) => (
              <Link key={group.title} to="/category/phu-tung-xe-dien" onClick={() => setMegaOpen(false)}>
                <strong>{group.title}</strong>
                <span>{group.description}</span>
              </Link>
            ))}
          </div>
        </div>
      </header>
      <Outlet />
      <section className="trust" aria-label="Cam kết dịch vụ">
        <div className="container trust-grid">
          <div className="trust-item">
            <span className="trust-icon">
              <Grid3X3 aria-hidden="true" />
            </span>
            <div>
              <strong>Đúng mã phụ tùng</strong>
              <span>Kiểm tra tương thích trước khi giao</span>
            </div>
          </div>
          <div className="trust-item">
            <span className="trust-icon">
              <ShoppingCart aria-hidden="true" />
            </span>
            <div>
              <strong>Đơn hàng minh bạch</strong>
              <span>Timeline và trạng thái rõ ràng</span>
            </div>
          </div>
          <div className="trust-item">
            <span className="trust-icon">
              <MessageSquare aria-hidden="true" />
            </span>
            <div>
              <strong>Hỏi là có</strong>
              <span>Sourcing phụ tùng khó tìm</span>
            </div>
          </div>
          <div className="trust-item">
            <span className="trust-icon">
              <Bell aria-hidden="true" />
            </span>
            <div>
              <strong>Thông báo chủ động</strong>
              <span>Email và cập nhật đơn hàng</span>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="container footer-grid">
          <div>
            <div className="footer-brand">
              <img src={logo} alt="Logo Siêu Thị Ưa Thích" />
              <div>
                <h4>Siêu Thị Ưa Thích</h4>
                <p>Phụ tùng chính hãng cho vận hành đa kênh.</p>
              </div>
            </div>
          </div>
          <div>
            <h4>Mua hàng</h4>
            <Link to="/category/phu-tung-xe-dien">Danh mục</Link>
            <Link to="/search">Tìm kiếm</Link>
            <Link to="/track-order">Tra cứu đơn</Link>
          </div>
          <div>
            <h4>Dịch vụ</h4>
            <Link to="/ask">Hỏi là có</Link>
            <Link to="/b2b">B2B / Đại lý</Link>
            <Link to="/warranty-policy">Bảo hành</Link>
          </div>
          <div>
            <h4>Chính sách</h4>
            <Link to="/privacy-policy">Bảo mật</Link>
            <Link to="/terms">Điều khoản</Link>
            <Link to="/return-policy">Đổi trả</Link>
          </div>
          <div>
            <h4>Nhận tin</h4>
            <p>Cập nhật hàng mới, bảng giá và mẹo kỹ thuật.</p>
            <form className="newsletter" onSubmit={(event) => event.preventDefault()}>
              <input aria-label="Email nhận tin" placeholder="email@domain.com" />
              <button type="submit">Đăng ký</button>
            </form>
          </div>
        </div>
        <div className="container copyright">
          <span>V3.1 production rebuild</span>
          <span>Không hard-code domain riêng</span>
        </div>
      </footer>
      <Link className="chat-fab" to="/ask">
        <MessageSquare aria-hidden="true" />
        Hỏi là có
      </Link>
      <nav className="mobile-nav" aria-label="Điều hướng di động">
        <NavLink to="/" className={navClass}>
          <Home aria-hidden="true" />
          Trang chủ
        </NavLink>
        <NavLink to="/search" className={navClass}>
          <Search aria-hidden="true" />
          Tìm
        </NavLink>
        <NavLink to="/ask" className={navClass}>
          <MessageSquare aria-hidden="true" />
          Hỏi
        </NavLink>
        <NavLink to="/cart" className={navClass}>
          <ShoppingCart aria-hidden="true" />
          Giỏ
        </NavLink>
        <NavLink to="/account" className={navClass}>
          <User aria-hidden="true" />
          Tôi
        </NavLink>
      </nav>
    </>
  );
}
